import React from "react";
import * as S from "./styles";
export var Facebook = function Facebook(e) {
  return React.createElement(S.SVG, Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    "aria-hidden": "true"
  }, e), React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    strokeLinecap: "round",
    d: "M16 1.714v12.572c0 .476-.167.88-.5 1.214-.333.333-.738.5-1.214.5H11.25V9.679h2.143l.321-2.429H11.25V5.714c0-.38.071-.666.214-.857.19-.214.512-.321.965-.321h1.285V2.393c-.5-.072-1.119-.107-1.857-.107-.952 0-1.708.28-2.268.839-.56.56-.839 1.34-.839 2.34V7.25H6.571v2.429H8.75V16H1.714c-.476 0-.88-.167-1.214-.5-.333-.333-.5-.738-.5-1.214V1.714C0 1.238.167.834.5.5.833.167 1.238 0 1.714 0h12.572c.476 0 .88.167 1.214.5.333.333.5.738.5 1.214z"
  }));
};